import React from "react";
import './Services.css'
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png"
import Card from "../Card/Card";
import Resume from './Resume.pdf';
import {themeContext} from '../../Context';
import { useContext } from "react";
// import {motion} from "framer-motion"

const Services = () => {

    const transition = {duration: 1,  type: 'spring'}
    const theme = useContext (themeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div className="services" id = 'Services'>

            {/* left side */}
            <div className="awesome">
            <span style={{color: darkMode? 'white': ''}}>Let's See</span>
            <span>What I Offer</span>
            <spane>Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                <br></br>
                 Nunc lobortis rhoncus nibh sit amet porttitor</spane>
                 <a href={Resume} download>
                 <button className="button s-button">See my Resume</button>
                 </a>
            
            <div className="blur s-blur" style={{ background: '#ABF1FF94'}}></div>
            </div>
           
            {/* right side */}
            <div className="cards">
                <div 
                whileInView = {{left: '14rem'}}
                initial = {{left: '25%'}}
                transition = {transition}
                
                
                style={{left: '14rem'}}>
                    <Card
                        emoji = {HeartEmoji}
                        heading = {'Web Design'}
                        detail = {'Figma, Adobe Photoshop, Adobe Xd'}
                    />
                </div>
                
                <div style={{top: "12rem", left: "-4rem"}}>
                    <Card
                        emoji = {Glasses}
                        heading = {'Web Development'}
                        detail = {'Figma, Adobe Photoshop, Adobe Xd'}
                    />
                </div>

                <div style={{top: "19rem", left: "12rem"}}>
                    <Card
                        emoji = {Humble}
                        heading = {'UI/UX Desgin'}
                        detail = {'Figma, Adobe Photoshop, Adobe Xd'}
                    />
                </div>
                <div className="blur s-blur2" style={{background: "var(--purple)" }}></div>
            </div>
        </div>
    )
}

export default Services